module.exports = __webpack_public_path__ + "media/components/maps/apps/icons/highlyPositive-ba31487502e050ae3c06420a8259624c.png";